import React from "react";
import { createRoot } from 'react-dom/client';
import { Provider } from "react-redux";
import App from "./App";
import store from "./store";
import { injectStore } from "~/helpers/apiHelper";
import AuthContext from "~/context/auth";
import AccessContext from "~/context/access";
import SocketContext from "~/context/socket";
import { randomStringSync } from '~/helpers/utilHelper';

injectStore(store);

// TEMPORARY create unique id for each tab opened by the user
if (!window.name) {
  window.name = randomStringSync(3)
}

const app = (
  <Provider store={store}>
    <AuthContext>
      <AccessContext>
        <SocketContext>
          <App />
        </SocketContext>
      </AccessContext>
    </AuthContext>
  </Provider>
);

const container = document.getElementById('root');
const root = createRoot(container);
root.render(app);
